export default "__VITE_ASSET__DAZw7NY5__"